import makeContextStore from "@common/util/makeContextStore";

import { AppReducer } from "./App.reducer";
import { AppState } from "./App.types";

export const initialAppContextState: AppState = {
  app: undefined,
  loading: true,
};

const [AppContextProvider, useAppContext, useAppDispatch] = makeContextStore(AppReducer, initialAppContextState);

export { AppContextProvider, useAppContext, useAppDispatch };
